<template>
  <!-- Navbar -->
  <nav
    class="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4"
  >
    <div
      class="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4"
    >
      <!-- Brand -->
      <a
        class="text-white text-xl uppercase hidden lg:inline-block font-semibold"
        href="javascript:void(0)"
      >
        <h6>Dashboard (Academic Year {{edu_year_arr.edu_year_grade}})</h6>
      </a>
      <!-- User -->
      <ul class="flex-col md:flex-row list-none items-center hidden md:flex">
        <user-dropdown /> 
      </ul>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script>
import UserDropdown from "@/components/Dropdowns/UserDropdown.vue";
import api from './../../services/student_services';

export default {
   name: "card-edu_year",
  data() {
        return {
            openTab: 1,
            edu_year_arr: [],

      
        }
    },
      methods: {

        async edu_year() {
            api.edu_year().then(async (result) => {
                this.edu_year_arr = result.data;
               
            });
        }
         

      },created: async function () {
        await this.edu_year()
    },
  components: {
    UserDropdown,
  },

};
</script>
